import { TuiTagModule } from '@taiga-ui/kit';
import { Maybe } from '@iss/libs/graphql';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';

import { CapitalizePipe } from '@iss/wo-common/pipes';
import { AvatarComponent } from '@iss/core/portal';

@Component({
  selector: 'wo-account-title',
  templateUrl: './account-title.component.html',
  styleUrls: [ './account-title.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AvatarComponent,
    CapitalizePipe,
    NgForOf,
    NgIf,
    TuiTagModule,
  ],
})
export class AccountTitleComponent {
  @Input() name: Maybe<string>;
  @Input() roles: Maybe<readonly string[]>;
}
